import BoxInfoTemplate from "../BoxInfoTEmplate/BoxInfoTemplate";
import Seo from "../Seo/Seo";

const SuccessPaymentPage = () => {
  return (
    <>
      <Seo title="Purchase Completed" path="/success" noIndex />
      <BoxInfoTemplate
        title="COMPRA COMPLETADA"
        subTitle="COMPRA COMPLETADA"
        mainText="Success! Purchase completed. Gracias amig@!! Book a lesson y nos vemos en clase! 😀."
        iconType="check"
        borderColor="green"
        showQuotes={false}
      />
    </>
  );
};

export default SuccessPaymentPage;
